import { useSelector } from 'react-redux'
import { CustomLink } from '../../../common/CustomLink'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { selectRelatedCompanyData } from '../store/slice'

export const NameCell = ({ val, rowId, isDynamicReport }) => {
  const organizationId = useSelector(
    selectRelatedCompanyData(rowId, 'organizationId'),
  )

  return (
    <CustomLink
      target="_blank"
      to={
        COMPONENTS.companyAnalysis.components.summary.route +
        '?organizationId=' +
        organizationId
      }
    >
      {isDynamicReport ? (
        formatText(val)
      ) : (
        <TextEllipsisStaticLine
          lineClamp={2}
          text={formatText(val)}
          isI18n={false}
          appendStyle={{
            color: '#2C73E8',
          }}
        />
      )}
    </CustomLink>
  )
}
